export const COMPARE = {
  TIME: {
    FUTURE: 'future',
    PAST: 'past',
    PAST_MORE_THAN_2_DAYS: 'pastMoreThan2Days',
    PAST_NOT_MORE_THAN_2_DAYS: 'pastNotMoreThan2Days',
  },
}